import { Size } from "@repo/ui/helpers/helpers";
import { entityTable } from "@repo/ui/tables/entityTable";
import type { FC, ReactNode } from "react";

export interface SettingsTableProps {
  className?: string;
  children: ReactNode;
}

export const SettingsTable: FC<SettingsTableProps> = (props) => (
  <table
    className={entityTable({ size: Size.SMALL }).table({
      className: props.className,
    })}
  >
    {props.children}
  </table>
);
